<template>
    <div class="main-block">
        <a
            class="vw-image-block"
            v-for="(product, index) in products"
            :key="index">
            <img :src="product.image" alt="">
            <strong>{{product.productName}}</strong>
        </a>
    </div>
</template>

<script>
import Layout from '@/views/Layout.vue';

export default {
    name: 'previewWechatCate',
    components: {
        Layout,
    },
    data() {
        return {
            pageName: '',
            products: [],
        };
    },
    mounted() {
        const self = this;
        // const { pageId } = this.$route.query;
        const getMessage = (event) => {
            console.log(event);
            if (!event.data.wechatCatePage) return;
            const result = event.data;
        // ajax.get('/web/wx/page_detail.json', {
        //     id: pageId,
        // }).then((result) => {
            self.pageName = result.data.pageName;
            self.products = result.data.pageProducts;
            window.removeEventListener('message', getMessage);
        // }).catch(() => {});
        };
        window.addEventListener('message', getMessage, false);
        if (window.opener) {
            window.opener.postMessage('wechatCateReady');
        }
    },
};
</script>
<style lang="less" scoped>
    .vw-image-block {
        display: block;
        position: relative;
        margin: 0 auto;
        padding-top: 20px;
        overflow: hidden;
        text-align: center;
        img {
            border-radius: 4px;
            width: 345px;
            height: 175px;
        }
        strong {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 32px;
            font-weight: 600;
            color: #fff;
        }
    }
</style>
